/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TruckUtilizationCharDataPoint
 */
export interface TruckUtilizationCharDataPoint {
    /**
     * 
     * @type {Date}
     * @memberof TruckUtilizationCharDataPoint
     */
    bucket: Date;
    /**
     * 
     * @type {number}
     * @memberof TruckUtilizationCharDataPoint
     */
    utilization: number;
}

/**
 * Check if a given object implements the TruckUtilizationCharDataPoint interface.
 */
export function instanceOfTruckUtilizationCharDataPoint(value: object): value is TruckUtilizationCharDataPoint {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('utilization' in value) || value['utilization'] === undefined) return false;
    return true;
}

export function TruckUtilizationCharDataPointFromJSON(json: any): TruckUtilizationCharDataPoint {
    return TruckUtilizationCharDataPointFromJSONTyped(json, false);
}

export function TruckUtilizationCharDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): TruckUtilizationCharDataPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': (new Date(json['bucket'])),
        'utilization': json['utilization'],
    };
}

export function TruckUtilizationCharDataPointToJSON(json: any): TruckUtilizationCharDataPoint {
    return TruckUtilizationCharDataPointToJSONTyped(json, false);
}

export function TruckUtilizationCharDataPointToJSONTyped(value?: TruckUtilizationCharDataPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucket': value['bucket'].toISOString(),
        'utilization': value['utilization'],
    };
}

